module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [_vm._m(0), _vm._v(" "), (_vm.showFlashMessage) ? _c('mu-flexbox', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('MessageBox', {
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-flexbox', {
    class: {
      'fullHeight': !_vm.showFlashMessage
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "reset-block"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Reset your password",
      "subTitle": "Use the form below to reset your password",
      "titleClass": "blueTitle largeTitle regTitle resetTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "name": "password",
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "Password",
      "errorText": _vm.errors.first('password'),
      "label": "New password",
      "type": "password",
      "hintText": "Enter desired password",
      "fullWidth": ""
    },
    on: {
      "change": _vm.triggerValidate
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('password-strength-validation', {
    attrs: {
      "password": _vm.model.password
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "name": "password_confirmation",
      "data-vv-name": "password_confirmation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": " ",
      "errorText": _vm.confirmPassErr,
      "label": "Confirm password",
      "type": "password",
      "hintText": "Confirm password",
      "fullWidth": ""
    },
    on: {
      "change": _vm.triggerValidate
    },
    model: {
      value: (_vm.model.password_confirm),
      callback: function($$v) {
        _vm.$set(_vm.model, "password_confirm", $$v)
      },
      expression: "model.password_confirm"
    }
  })], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSending,
      "type": "button",
      "label": "Reset Password",
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "tablet": "25"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/logos/lcp-logo.svg"),
      "width": "312",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ccd3c1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PasswordReset/PasswordReset.vue
// module id = 3712
// module chunks = 1